import { http } from "@/lib/request";

export interface CommentGoodsInfoResult {
  order_goods_id: number;
  goods_id: number;
  is_comment: number;
  appoint_date?: string;
  appoint_time?: string;
  goods_price?: number;
  coach_info?: {
    id?: number;
    name?: string;
    work_photo?: string;
  };
  goods_snap?: {
    id?: number;
    name?: string;
    image?: string;
    duration?: number;
    goods_num?: number;
    price?: number;
  };
  comment?: Record<string, unknown>;
}

export interface CommentDetailResult {
  id?: number;
  avatar?: string;
  nickname?: string;
  create_time?: string;
  service_comment?: number;
  comment?: string;
  tags?: string[];
  reply?: string;
  goods_comment_image?: Array<{
    uri?: string;
    image?: string;
  }>;
}

export const commentApi = {
  getCommentGoodsInfo(orderGoodsId: number) {
    return http.get<CommentGoodsInfoResult>("/goods_comment/commentGoodsInfo", {
      params: { order_goods_id: orderGoodsId },
    });
  },

  getCommentDetail(id: number) {
    return http.get<CommentDetailResult>("/goods_comment/commentDetail", {
      params: { id },
    });
  },

  submitComment(payload: {
    order_goods_id: number;
    service_comment: number;
    comment?: string;
    tags?: string[];
    image?: string[];
  }) {
    return http.post<void>("/goods_comment/add", {
      image: [],
      ...payload,
    });
  },
};
